import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

import { BaseRendererComponent } from 'tms-lib';

// Mirror of XeroConstants.Overdue / XeroConstants.ToPay in the API. OverdueStatus is only
// set on invoices, which is what keeps credit notes and overpayments chip-free here.
const overdueStatus = 'OVERDUE';
const toPayStatus = 'TO PAY';

@Component({
  selector: 'app-credit-check-status-renderer',
  templateUrl: './credit-check-status-renderer.component.html',
  styleUrl: './credit-check-status-renderer.component.scss',
})
export class CreditCheckStatusRendererComponent extends BaseRendererComponent implements ICellRendererAngularComp {
  // The wording is an ICU plural in the TEMPLATE, not a ternary here: $localize does no ICU
  // expansion at runtime, so a plural assembled in TypeScript can only ever carry English's
  // two forms. See the i18n note in ui.md.
  get isOverdue(): boolean {
    return this.rowData?.overdueStatus === overdueStatus;
  }

  get isDue(): boolean {
    return this.rowData?.overdueStatus === toPayStatus;
  }

  // DaysLate is negative when overdue (API: DueDate minus today/paid date), so the overdue
  // chip counts up from zero while the not-yet-due chip counts down to it.
  get daysOverdue(): number {
    return -(this.rowData?.daysLate ?? 0);
  }

  get daysUntilDue(): number {
    return this.rowData?.daysLate ?? 0;
  }

  get chipClass(): string {
    const days = this.daysOverdue;
    if (days <= 0) {
      return 'credit-status-chip chip-current';
    }
    if (days <= 30) {
      return 'credit-status-chip chip-b1';
    }
    return days <= 90 ? 'credit-status-chip chip-b2' : 'credit-status-chip chip-b3';
  }
}
